import { render } from "./CalltoActions.vue?vue&type=template&id=25ec4dc2&scoped=true"
import script from "./CalltoActions.vue?vue&type=script&lang=js"
export * from "./CalltoActions.vue?vue&type=script&lang=js"

import "./CalltoActions.vue?vue&type=style&index=0&id=25ec4dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ec4dc2"]])

export default __exports__